<template>
  <div class="flex">
    <div v-for="day in range" :key="day">
      <div
        class="w-8 h-8 border border-gray-300 flex justify-center items-center cursor-pointer border-r-0 hover:bg-secondary-50"
        :class="{
          'rounded-r-md !border-r': range[range.length - 1] === day,
          'rounded-l-md': range[0] === day,
          'bg-secondary text-white hover:bg-secondary': context._value == day,
        }"
        @click="handleInput(day)"
      >
        {{ day }}
      </div>
      <input
        :id="context.attrs.id"
        class="hidden"
        type="radio"
        :value="day"
        :name="context.node.name"
        :disabled="context.disabled === true"
        :checked="context._value == day"
        v-bind="$attrs"
        @blur="context.handlers.blur"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { computed } from 'vue'

const props = defineProps<{ context: FormKitFrameworkContext; min?: number; max?: number }>()
const range = computed(() => {
  const start = props.min ?? 1
  const end = props.max ?? 7
  const days = end - start
  return [...Array(days)].map((_, i) => i + start)
})

const handleInput = (day: number) => {
  props.context.node.input(day)
}
</script>
